import { useState, useEffect } from "react";
import BlogCard from "./BlogCard";
import "./Blogs.css";
import '../Contact/Locations/Locations.css';
import Pagination from "./Pagination/Pagination";
import { Link } from "react-router-dom";
import probnr from '../../../assets/img/pdct_bnr.webp'

function Blogs() {
const [blogs, setBlogs] = useState([]);
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);


const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 12,
    total: 0,
    from: null,
    to: null,
});

const fetchBlogs = async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
        const params = new URLSearchParams({
            per_page: pagination.per_page.toString(),
            page: page.toString(),
            status: "published",
        });

        const response = await fetch(
            `https://admin.360-bytes.com/api/getBlogs?${params}`
        );

        if (!response.ok) {
            throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        setBlogs(result.data);
        
        setPagination(result.pagination);
    } catch (error) {
        setError(error.message);
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
    fetchBlogs(1);
}, []);

const handlePageChange = (page) => {
    if (
        page < 1 ||
        page > pagination.last_page ||
        page === pagination.current_page ||
        loading
    ) {
        return;
    }

    fetchBlogs(page);
};

return (
    <>
        <section className='hmslder-sec abt-sec'>
            <div className='breadcrumbs'>
                <div className='container'>
                    <ul>
                        <li><Link to='/'>Home</Link></li> 
                        <li>Blogs</li>   
                    </ul> 
                </div> 
            </div>
            {/* <div className='container'>
                <div className='hmslder-txt'>
                    <h2>How Can <span>We Help</span> </h2>
                    <p>Mobile Application, Website Solution, Digital Transformation, Customized  IT Software, we are here to help you achieve your objective. Please let  us know and our team of experts will meet you to take things further.</p>
                </div>
                <div className='hmslder-img'>
                    <img src={probnr} alt='Blogs' width={1200} height={600} loading="lazy" />
                </div>
            </div> */}
        </section>

        <section className='cont-sec'>
            <div className='container'>
                <div className='mn-head'>
                    <h5>Latest Blogs</h5>
                    <h3>Our Latest Insights</h3>
                </div>
                <ul>
                    {
                        blogs.map((blog, index) => (
                            <BlogCard key={index} blog={blog} />
                        ))
                    }
                </ul>
            </div>
        </section>

        <Pagination pagination={pagination} loading={loading} handlePageChange={handlePageChange} />
    </>

);

}

export default Blogs;